var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGroupsActive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22.983 23a8 8 0 0 0-16 0zm-8-9c3.315 0 6-2.685 6-6s-2.685-6-6-6-6 2.685-6 6 2.685 6 6 6M7.62 16.233A7.505 7.505 0 0 0 2 23h2.983c0-2.61 1-4.986 2.637-6.767m2.023-2.276A7.98 7.98 0 0 1 6.983 8a7.96 7.96 0 0 1 1.015-3.903 5 5 0 0 0 1.645 9.86"
})));
export default SvgGroupsActive;